<template>
  <div class="page-container">
    <div class="query-title">经销商分流客户查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="导出" @click="exportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="left"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          />
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { findDealerShuntClientsPage } from '@/api/applyForGoods/index'
import tableMixins from '@/utils/tableMixins'
import pageConfig from './config/dealerShuntClientsSearch'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
import { mapGetters } from 'vuex'

export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [],
        data: []
      },
      searchField: {},
      isSetFilter: false
    }
  },
  computed: {
    ...mapGetters(['role'])
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      
      const params = {
        user_bp: this.role.USER_BP,
        role: this.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const result = await findDealerShuntClientsPage(params)
        // 适配后端返回的数据结构: { data: { Rows: [], Total: 1 } }
        const data = result?.data || result || {}
        const records = data.Rows || data.records || []
        const total = data.Total || data.total || 0
        
        if (records.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        
        this.pagination.totalCount = total - 0
        this.gridOptions.data = records
        
        // 如果是第一次查询，需要设置筛选选项
        if (ranges && !this.isSetFilter) {
          // 根据返回的数据生成筛选选项
          this.generateFilterOptions(records)
          this.isSetFilter = true
        }
      } catch (e) {
        console.error('查询失败', e)
        this.$message.error(e.message || '查询失败，请稍后重试')
      }
      this.loading = false
    },
    
    // 生成筛选选项
    generateFilterOptions(data) {
      if (!data || data.length === 0) return
      
      const filterFields = ['customerCode', 'customerName', 'distributorCode', 'distributorName', 'channels', 'startup']
      const optionsMap = {}
      
      filterFields.forEach(field => {
        const values = new Set()
        data.forEach(item => {
          if (item[field]) {
            values.add(item[field])
          }
        })
        optionsMap[field] = Array.from(values).map(value => ({ label: value, value }))
      })
      
      this.allOptions = optionsMap
      this.setFilter()
    },
    
    // 导出功能
    async exportExcel() {
      const params = {
        user_bp: this.role.USER_BP,
        role: this.role.ROLE,
        ...this.allConditions
      }
      
      try {
        const result = await findDealerShuntClientsPage(params)
        // 适配后端返回的数据结构
        const resultData = result?.data || result || {}
        const data = resultData.Rows || resultData.records || []
        frontExport(this.gridOptions.columns, data, '经销商分流客户查询')
      } catch (e) {
        console.error('导出失败', e)
        this.$message.error(e.message || '导出失败，请稍后重试')
      }
    },
    
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 20px;
}

.query-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.content {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}

.table-container {
  margin-top: 20px;
}
</style>




// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/dealerShuntClientsSearch.vue